// Libellés et descriptions des modes d'entraînement.
//
// La base ne connaît que les codes de l'ENUM `training_mode` ; le texte vit
// ici. Deux écrans en ont besoin — le choix de l'exercice et l'accueil, qui
// rappelle ce qui n'a pas été travaillé depuis longtemps — d'où ce module
// plutôt qu'une constante enfermée dans une page.

import type { TrainingModeCode } from '@golf/common';

export interface ModeMeta {
    mode: TrainingModeCode;
    label: string;
    description: string;
    /** Se joue à plusieurs. Aucun mode de practice ne l'est : on ne partage
     *  pas un tapis, et les statistiques suivent un joueur et son club. Le
     *  putting, lui, se joue à plusieurs autour du même green — d'où la
     *  pastille, qui évite d'ouvrir un mode pour découvrir qu'il est solitaire. */
    multiplayer?: boolean;
}

export const MODES: ModeMeta[] = [
    {
        mode: 'triple_shot',
        label: 'Triple Shot',
        description: "Trois balles d'affilée avec le même club, puis on change. "
            + "Travaille l'alternance.",
    },
    {
        mode: 'feet_together',
        label: 'Pieds joints',
        description: 'Balles frappées les pieds serrés. '
            + 'Travaille l\'équilibre et le centrage de frappe.',
    },
    {
        mode: 'free',
        // « Exercice » et non « séance » : une séance est désormais une suite
        // d'exercices, préparée à l'avance. Garder l'ancien mot ici mettait le
        // plus petit objet et le plus grand sous le même nom, dans deux écrans
        // voisins.
        label: 'Exercice libre',
        description: 'Votre propre exercice : vous le décrivez, vous prenez le club '
            + 'que vous voulez et vous changez quand vous voulez.',
    },
];

/** Le code brut en dernier recours : un mode ajouté en base sans son libellé
 *  doit rester identifiable plutôt que disparaître de l'écran. */
export const modeLabel = (mode: string): string =>
    MODES.find((m) => m.mode === mode)?.label ?? mode;
